export { default } from './cannabinoid-modal';
